import { useState, useEffect, Fragment } from "react";
import FleetWebApi from "../Api/FleetWebApi";
import CircularProgress from "@mui/material/CircularProgress";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Grid from "@mui/material/Grid";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Container from "@mui/material/Container";
import { Paper, TableHead } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Switch from "@mui/material/Switch";
import IconButton from "@mui/material/IconButton";
import Moment from "react-moment";
import { CSVLink } from "react-csv";

function UsersTeams(props) {
  const [report, setReport] = useState([]);
  const [timestamp, setTimestamp] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [alEmails, setAlEmails] = useState(false);
  const [start, setStart] = useState(0);
  const [finish, setFinish] = useState(100);
  const [data, setData] = useState([]);

  const nextPage = () => {
    setStart(start + 10);
    setFinish(finish + 10);
  };

  const previousPage = () => {
    setStart(start - 10);
    setFinish(finish - 10);
  };

  const changeAlEmail = () => {
    setAlEmails(!alEmails);
  };

  useEffect(() => {
    setData(report.slice(start, finish));
  }, [report, start, finish]);

  useEffect(() => {
    setIsLoading(true);
    FleetWebApi.getUserReport(alEmails)
      .then((response) => {
        setReport(response.data);
        setTimestamp(response.timestamp);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setError(error.message);
        setIsLoading(false);
      });
  }, [alEmails]);

  return (
    <Fragment>
      <h1>Users Report</h1>
      {error && <p>Error Loading Data: {error}</p>}
      <Grid container spacing={3}>
        {!isLoading && (
          <div>
            {!error && !isLoading && timestamp && (
              <Moment format="YYYY-MM-DD HH:mm:ss Z">{timestamp}</Moment>
            )}

            <FormGroup>
              <FormControlLabel
                control={
                  <Switch onChange={changeAlEmail} defaultChecked={alEmails} />
                }
                label="Include alertlabs emails"
              />
            </FormGroup>

            <CSVLink
              data={report}
              filename={"user_report_AL_" + alEmails + ".csv"}
            >
              Download CSV
            </CSVLink>
          </div>
        )}
        {isLoading && <CircularProgress color="secondary" />}
        <Grid item xs={12} md={12} lg={12}>
          <Paper>
            <Container>
              <br />
              <Table style={{ tableLayout: "auto" }}>
                <TableHead>
                  <TableRow>
                    <TableCell>E-Mail</TableCell>
                    <TableCell>Company</TableCell>
                    <TableCell>Number of Locations</TableCell>
                    <TableCell>Team Members</TableCell>
                    <TableCell>Total Shares</TableCell>
                    <TableCell>Accepted Shares</TableCell>
                    <TableCell>Pending Shares</TableCell>
                    <TableCell>Last Login</TableCell>
                    <TableCell>E-mail alerts</TableCell>
                    <TableCell>SMS</TableCell>
                    <TableCell>Push</TableCell>
                    <TableCell>Phone</TableCell>
                    <TableCell>FlowieO</TableCell>
                    <TableCell>Hubbie</TableCell>
                    <TableCell>WaterMeter</TableCell>
                    <TableCell>SumpPit</TableCell>
                    <TableCell>Puck</TableCell>
                    <TableCell>Sentree</TableCell>
                    <TableCell>Shuttie</TableCell>
                    <TableCell>Humie</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.length !== 0 &&
                    data.map((member, key) => (
                      <TableRow key={key}>
                        <TableCell>{member.email}</TableCell>
                        <TableCell>{member.company}</TableCell>
                        <TableCell>{member.NumLocations}</TableCell>
                        <TableCell>{member.TeamMembers}</TableCell>
                        <TableCell>{member.TotalShares}</TableCell>
                        <TableCell>{member.AcceptedShares}</TableCell>
                        <TableCell>{member.PendingShares}</TableCell>
                        {member.LastLogin ? (
                          <TableCell>
                            <Moment format="YYYY-MM-DD HH:mm:ss Z">
                              {member.LastLogin}
                            </Moment>
                          </TableCell>
                        ) : (
                          <TableCell>-</TableCell>
                        )}
                        <TableCell>{String(member.EmailAlerts)}</TableCell>
                        <TableCell>{String(member.sms)}</TableCell>
                        <TableCell>{String(member.push)}</TableCell>
                        {member.phone ? (
                          <TableCell>{String(member.phone)}</TableCell>
                        ) : (
                          <TableCell>false</TableCell>
                        )}
                        <TableCell>{String(member.FlowieO)}</TableCell>
                        <TableCell>{String(member.hubbie)}</TableCell>
                        <TableCell>{String(member.WaterMeter)}</TableCell>
                        <TableCell>{String(member.SumpPit)}</TableCell>
                        <TableCell>{String(member.puck)}</TableCell>
                        <TableCell>{String(member.sentree)}</TableCell>
                        <TableCell>{String(member.shuttie)}</TableCell>
                        <TableCell>{String(member.humie)}</TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
              {start !== 0 && (
                <IconButton onClick={previousPage}>
                  <ArrowBackIcon />
                </IconButton>
              )}
              {finish !== 10 && start + 10 <= report.length && (
                <IconButton onClick={nextPage}>
                  <ArrowForwardIcon />
                </IconButton>
              )}
            </Container>
            {isLoading && <CircularProgress color="secondary" />}
          </Paper>
        </Grid>
      </Grid>
    </Fragment>
  );
}

export default UsersTeams;
